import { getCdnUrl } from '@/utils/url';
import SubMenuBox from './sub-menu-box';
import { MenuItems } from '../../constants';
import { MenuItem, MobileMenuItems } from '../../types';
import { useLayoutMenu } from '../../utils/layout-menu';
function MenuGrouping() {
  const {
    data: layoutMenu
  } = useLayoutMenu();
  const MENU_GROUPS: MenuItem[] = [{
    title: 'پیشنهاد ویژه',
    icon: getCdnUrl('/_toad/app-icons/menu/shine-star.svg'),
    id: MobileMenuItems.SpecialOffer,
    isLinkInDrawer: true,
    href: layoutMenu?.promotedUrl || ''
  }, {
    title: 'برندها',
    icon: getCdnUrl('/_toad/app-icons/menu/brands.svg'),
    id: MobileMenuItems.Brands,
    href: '',
    isLinkInDrawer: false
  }];
  return <div className='relative grid grid-cols-2 gap-2 px-2 pt-6' id='menu-grouping' data-sentry-component="MenuGrouping" data-sentry-source-file="menu-grouping.tsx">
            {[...MENU_GROUPS, ...MenuItems].map(item => {
      return <div key={item.id}>
                        <SubMenuBox {...item} subMenuChildren={item.children} />
                    </div>;
    })}
        </div>;
}
export default MenuGrouping;